import paywallRedeemTreeDots1Svg from '~/assets/figma/paywall-redeem-tree-dots1.svg'
import paywallRedeemTreeDots2Svg from '~/assets/figma/paywall-redeem-tree-dots2.svg'
import paywallRedeemTreeTagSvg from '~/assets/figma/paywall-redeem-tree-tag.svg'
import paywallRedeemTreeSvg from '~/assets/figma/paywall-redeem-tree.svg'

type IconProps = { class?: string }

export function PaywallIconBox(props: IconProps) {
  return (
    <svg
      class={props.class}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        opacity="0.1"
        d="M17.401 37.6009C13.4273 37.6009 9.39842 37.5436 5.4248 37.4291C3.93788 37.3842 2.62965 36.2903 2.3829 34.8815C1.87237 31.9413 1.87237 28.9643 2.3829 26.0262C2.62965 24.6133 3.93788 23.5195 5.42267 23.4745C9.39629 23.36 13.4252 23.3027 17.3988 23.3027C21.3725 23.3027 25.4014 23.36 29.375 23.4745C30.8619 23.5195 32.168 24.6133 32.4169 26.0221C32.9274 28.9623 32.9274 31.9413 32.4169 34.8774C32.168 36.2903 30.8619 37.3842 29.3771 37.4271C25.4014 37.5416 21.3725 37.5988 17.3988 37.5988L17.401 37.6009Z"
        fill="black"
      />
      <path
        d="M30.6743 16.3848H4.12677V30.4519H30.6743V16.3848Z"
        fill="#7B72F2"
      />
      <path
        d="M29.313 21.3163C21.3722 21.5433 13.4292 21.5433 5.48834 21.3163C5.02035 21.302 4.56088 20.9238 4.48217 20.4739C4.00993 17.7484 4.00993 15.0209 4.48217 12.2954C4.56088 11.8435 5.02035 11.4653 5.48834 11.453C13.4292 11.224 21.3722 11.224 29.313 11.453C29.781 11.4673 30.2405 11.8456 30.3192 12.2954C30.7914 15.0209 30.7914 17.7484 30.3192 20.4739C30.2405 20.9258 29.781 21.3041 29.313 21.3163Z"
        fill="#9C91F6"
      />
      <path
        d="M29.313 35.3857C21.3722 35.6126 13.4292 35.6126 5.48834 35.3857C5.02035 35.3714 4.56088 34.9931 4.48217 34.5433C4.00993 31.8178 4.00993 29.0902 4.48217 26.3647C4.56088 25.9129 5.02035 25.5346 5.48834 25.5223C13.4292 25.2933 21.3722 25.2933 29.313 25.5223C29.781 25.5366 30.2405 25.9149 30.3192 26.3647C30.7914 29.0902 30.7914 31.8178 30.3192 34.5433C30.2405 34.9951 29.781 35.3734 29.313 35.3857Z"
        fill="#7B72F2"
      />
      <path
        d="M21.7401 27.0003C21.4699 26.7795 19.7852 26.7815 18.4089 27.5708C17.9792 27.8161 17.6473 28.1065 17.4006 28.3948C17.1559 28.1065 16.822 27.8161 16.3923 27.5708C15.0181 26.7815 13.3333 26.7795 13.0611 27.0003C12.7739 27.2334 12.91 28.497 14.2863 29.2862C15.1542 29.7851 16.1838 30.0059 16.9219 30.0223C16.8645 30.7952 16.79 31.8297 16.79 31.8297C16.7645 32.6599 18.0345 32.6599 18.0089 31.8297L17.877 30.0223C18.6152 30.0059 19.6448 29.7851 20.5127 29.2862C21.8868 28.497 22.023 27.2334 21.7379 27.0003H21.7401Z"
        fill="white"
      />
      <path
        d="M13.9973 16.5629L19.6217 14.6001C24.7397 16.1336 29.1622 21.6745 29.1601 25.2383L26.3904 24.6986L24.4334 27.0785C22.9359 22.382 18.2241 18.1394 13.9995 16.5629H13.9973Z"
        fill="#FFDE79"
      />
      <path
        d="M17.401 11.1747C18.6837 9.12802 21.9085 5.55195 27.1457 7.23878C31.2788 8.57188 31.3682 12.8799 29.8983 15.3171C27.9881 18.4822 22.553 17.8729 17.4031 16.3129L16.3395 13.4524L17.4031 11.1727L17.401 11.1747Z"
        fill="#FFDE79"
      />
      <path
        d="M27.1727 15.3877C24.2287 16.8803 20.2699 15.7987 19.0064 15.0871C20.3316 13.2633 22.9141 10.8118 26.6643 12.014C28.7149 12.6704 28.5554 14.6884 27.1727 15.3877Z"
        fill="#EBA14D"
      />
      <path
        d="M20.804 16.5629L15.1797 14.6001C10.0616 16.8737 5.76468 21.4558 5.3988 25.2383L7.91741 24.7476L10.1255 27.0785C10.67 22.9729 16.5794 18.1394 20.804 16.5629Z"
        fill="#FFDE79"
      />
      <path
        d="M17.4011 11.1747C16.1205 9.12802 12.8935 5.55195 7.65849 7.23878C3.52321 8.56984 3.43386 12.8799 4.90589 15.3171C6.81612 18.4822 12.2511 17.8729 17.4011 16.3129L18.4647 13.4524L17.4011 11.1727V11.1747Z"
        fill="#FFDE79"
      />
      <path
        d="M7.62837 15.3877C10.5724 16.8803 14.5311 15.7987 15.7947 15.0871C14.4695 13.2633 11.887 10.8118 8.13677 12.014C6.08614 12.6704 6.24568 14.6884 7.62837 15.3877Z"
        fill="#EBA14D"
      />
      <mask
        id="paywall-icon-box-mask"
        maskUnits="userSpaceOnUse"
        x="22"
        y="23.7998"
        width="19"
        height="16"
        fill="black"
      >
        <rect fill="white" x="22" y="23.7998" width="19" height="16" />
        <path d="M28.6826 36.7178C28.0127 36.7178 27.6162 36.2939 27.6162 35.5693V33.8535H25.9619C25.2783 33.8535 24.875 33.4639 24.875 32.8076C24.875 32.1582 25.2783 31.7686 25.9619 31.7686H27.6162V30.0391C27.6162 29.3213 28.0195 28.8975 28.6826 28.8975C29.3594 28.8975 29.7559 29.3213 29.7559 30.0391V31.7686H31.4033C32.0869 31.7686 32.4971 32.1582 32.4971 32.8076C32.4971 33.4639 32.0801 33.8535 31.3896 33.8535H29.7559V35.5762C29.7559 36.2939 29.3594 36.7178 28.6826 36.7178ZM37.4463 36.957C36.7012 36.957 36.1953 36.4717 36.1953 35.7197V29.1504H36.1475L34.917 30.0049C34.6914 30.1621 34.541 30.2168 34.3018 30.2168C33.8164 30.2168 33.4541 29.8545 33.4541 29.3486C33.4541 28.9863 33.5977 28.7061 33.9531 28.46L35.8193 27.1885C36.3457 26.833 36.7695 26.7783 37.2617 26.7783C38.1641 26.7783 38.6904 27.3184 38.6904 28.1797V35.7197C38.6904 36.4717 38.1914 36.957 37.4463 36.957Z" />
      </mask>
      <path
        d="M28.6826 36.7178C28.0127 36.7178 27.6162 36.2939 27.6162 35.5693V33.8535H25.9619C25.2783 33.8535 24.875 33.4639 24.875 32.8076C24.875 32.1582 25.2783 31.7686 25.9619 31.7686H27.6162V30.0391C27.6162 29.3213 28.0195 28.8975 28.6826 28.8975C29.3594 28.8975 29.7559 29.3213 29.7559 30.0391V31.7686H31.4033C32.0869 31.7686 32.4971 32.1582 32.4971 32.8076C32.4971 33.4639 32.0801 33.8535 31.3896 33.8535H29.7559V35.5762C29.7559 36.2939 29.3594 36.7178 28.6826 36.7178ZM37.4463 36.957C36.7012 36.957 36.1953 36.4717 36.1953 35.7197V29.1504H36.1475L34.917 30.0049C34.6914 30.1621 34.541 30.2168 34.3018 30.2168C33.8164 30.2168 33.4541 29.8545 33.4541 29.3486C33.4541 28.9863 33.5977 28.7061 33.9531 28.46L35.8193 27.1885C36.3457 26.833 36.7695 26.7783 37.2617 26.7783C38.1641 26.7783 38.6904 27.3184 38.6904 28.1797V35.7197C38.6904 36.4717 38.1914 36.957 37.4463 36.957Z"
        fill="white"
      />
      <path
        d="M27.6162 33.8535H29.6162V31.8535H27.6162V33.8535ZM27.6162 31.7686V33.7686H29.6162V31.7686H27.6162ZM29.7559 31.7686H27.7559V33.7686H29.7559V31.7686ZM29.7559 33.8535V31.8535H27.7559V33.8535H29.7559ZM28.6826 36.7178V34.7178C28.7813 34.7178 29.0912 34.7615 29.3624 35.0529C29.4834 35.1829 29.5504 35.3163 29.5843 35.4169C29.6006 35.4655 29.6086 35.5043 29.6124 35.5298C29.6162 35.5553 29.6162 35.5691 29.6162 35.5693H27.6162H25.6162C25.6162 36.2841 25.815 37.1124 26.434 37.7776C27.0709 38.4622 27.914 38.7178 28.6826 38.7178V36.7178ZM27.6162 35.5693H29.6162V33.8535H27.6162H25.6162V35.5693H27.6162ZM27.6162 33.8535V31.8535H25.9619V33.8535V35.8535H27.6162V33.8535ZM25.9619 33.8535V31.8535C25.9936 31.8535 26.271 31.8679 26.5496 32.1363C26.838 32.4141 26.875 32.72 26.875 32.8076H24.875H22.875C22.875 33.5515 23.1136 34.3804 23.7746 35.0171C24.4258 35.6443 25.2466 35.8535 25.9619 35.8535V33.8535ZM24.875 32.8076H26.875C26.875 32.9043 26.8345 33.2119 26.5462 33.4883C26.2687 33.7544 25.9936 33.7686 25.9619 33.7686V31.7686V29.7686C25.2467 29.7686 24.4281 29.9776 23.778 30.6009C23.1172 31.2344 22.875 32.0615 22.875 32.8076H24.875ZM25.9619 31.7686V33.7686H27.6162V31.7686V29.7686H25.9619V31.7686ZM27.6162 31.7686H29.6162V30.0391H27.6162H25.6162V31.7686H27.6162ZM27.6162 30.0391H29.6162C29.6162 30.046 29.61 30.3005 29.3588 30.568C29.0928 30.8514 28.7891 30.8975 28.6826 30.8975V28.8975V26.8975C27.913 26.8975 27.0761 27.1555 26.4427 27.8302C25.8241 28.4891 25.6162 29.3143 25.6162 30.0391H27.6162ZM28.6826 28.8975V30.8975C28.5933 30.8975 28.2869 30.8577 28.0149 30.568C27.8931 30.4382 27.8245 30.3039 27.7894 30.2007C27.7559 30.1018 27.7559 30.041 27.7559 30.0391H29.7559H31.7559C31.7559 29.3231 31.5544 28.4941 30.9311 27.8302C30.2918 27.1492 29.4487 26.8975 28.6826 26.8975V28.8975ZM29.7559 30.0391H27.7559V31.7686H29.7559H31.7559V30.0391H29.7559ZM29.7559 31.7686V33.7686H31.4033V31.7686V29.7686H29.7559V31.7686ZM31.4033 31.7686V33.7686C31.3722 33.7686 31.103 33.7548 30.829 33.4946C30.542 33.2218 30.4971 32.914 30.4971 32.8076H32.4971H34.4971C34.4971 32.0518 34.2471 31.2244 33.584 30.5946C32.9341 29.9771 32.118 29.7686 31.4033 29.7686V31.7686ZM32.4971 32.8076H30.4971C30.4971 32.7005 30.5431 32.3919 30.8311 32.1206C31.1036 31.8641 31.3673 31.8535 31.3896 31.8535V33.8535V35.8535C32.1024 35.8535 32.9199 35.6481 33.5734 35.0327C34.2426 34.4025 34.4971 33.571 34.4971 32.8076H32.4971ZM31.3896 33.8535V31.8535H29.7559V33.8535V35.8535H31.3896V33.8535ZM29.7559 33.8535H27.7559V35.5762H29.7559H31.7559V33.8535H29.7559ZM29.7559 35.5762H27.7559C27.7559 35.5742 27.7559 35.5134 27.7894 35.4146C27.8245 35.3113 27.8931 35.177 28.0149 35.0472C28.2869 34.7576 28.5933 34.7178 28.6826 34.7178V36.7178V38.7178C29.4487 38.7178 30.2918 38.4661 30.9311 37.7851C31.5544 37.1212 31.7559 36.2922 31.7559 35.5762H29.7559ZM36.1953 29.1504H38.1953V27.1504H36.1953V29.1504ZM36.1475 29.1504V27.1504H35.5211L35.0067 27.5077L36.1475 29.1504ZM34.917 30.0049L33.7762 28.3621L33.7734 28.3641L34.917 30.0049ZM33.9531 28.46L32.827 26.8071L32.8208 26.8113L32.8147 26.8156L33.9531 28.46ZM35.8193 27.1885L34.7 25.531L34.6932 25.5356L35.8193 27.1885ZM37.4463 36.957V34.957C37.5139 34.957 37.7317 34.9865 37.9416 35.1923C38.1563 35.4028 38.1953 35.6338 38.1953 35.7197H36.1953H34.1953C34.1953 36.5576 34.4873 37.4073 35.1411 38.0484C35.7903 38.6849 36.6336 38.957 37.4463 38.957V36.957ZM36.1953 35.7197H38.1953V29.1504H36.1953H34.1953V35.7197H36.1953ZM36.1953 29.1504V27.1504H36.1475V29.1504V31.1504H36.1953V29.1504ZM36.1475 29.1504L35.0067 27.5077L33.7762 28.3621L34.917 30.0049L36.0578 31.6476L37.2883 30.7931L36.1475 29.1504ZM34.917 30.0049L33.7734 28.3641C33.7353 28.3906 33.8108 28.3319 33.9568 28.281C34.1222 28.2235 34.2568 28.2168 34.3018 28.2168V30.2168V32.2168C34.5859 32.2168 34.9154 32.1828 35.2722 32.0586C35.6096 31.9411 35.8731 31.7764 36.0606 31.6457L34.917 30.0049ZM34.3018 30.2168V28.2168C34.5716 28.2168 34.8809 28.325 35.122 28.5701C35.3625 28.8147 35.4541 29.1121 35.4541 29.3486H33.4541H31.4541C31.4541 30.9272 32.6803 32.2168 34.3018 32.2168V30.2168ZM33.4541 29.3486H35.4541C35.4541 29.4443 35.4316 29.6266 35.323 29.8242C35.2197 30.012 35.1026 30.0967 35.0915 30.1043L33.9531 28.46L32.8147 26.8156C32.4482 27.0693 32.0816 27.4172 31.8177 27.8973C31.5484 28.3871 31.4541 28.8907 31.4541 29.3486H33.4541ZM33.9531 28.46L35.0792 30.1128L36.9454 28.8413L35.8193 27.1885L34.6932 25.5356L32.827 26.8071L33.9531 28.46ZM35.8193 27.1885L36.9387 28.8459C36.9861 28.8139 37.0138 28.8003 37.0241 28.7957C37.0333 28.7915 37.036 28.791 37.0367 28.7908C37.041 28.7897 37.0843 28.7783 37.2617 28.7783V26.7783V24.7783C36.5307 24.7783 35.6686 24.877 34.7 25.531L35.8193 27.1885ZM37.2617 26.7783V28.7783C37.3127 28.7783 37.1174 28.7858 36.9052 28.5752C36.6924 28.3638 36.6904 28.1589 36.6904 28.1797H38.6904H40.6904C40.6904 27.3391 40.4253 26.4336 39.7237 25.7368C39.0228 25.0408 38.1131 24.7783 37.2617 24.7783V26.7783ZM38.6904 28.1797H36.6904V35.7197H38.6904H40.6904V28.1797H38.6904ZM38.6904 35.7197H36.6904C36.6904 35.6418 36.7259 35.4113 36.942 35.1978C37.155 34.9873 37.3778 34.957 37.4463 34.957V36.957V38.957C38.2599 38.957 39.1048 38.6841 39.7536 38.0429C40.4054 37.3988 40.6904 36.5496 40.6904 35.7197H38.6904Z"
        fill="#7B72F2"
        mask="url(#paywall-icon-box-mask)"
      />
    </svg>
  )
}

export function PaywallIconStamp(props: IconProps) {
  // Layered SVG composite matching Figma node 3754:92953. All positions are
  // percentages of the 42×42 frame so the icon scales cleanly with any size
  // the caller passes via `class`.
  return (
    <div class={`relative ${props.class ?? ''}`}>
      <img
        src={paywallRedeemTreeSvg}
        alt=""
        aria-hidden="true"
        class="absolute left-0 top-[9.05%] h-[90.48%] w-[88.10%]"
      />
      <img
        src={paywallRedeemTreeDots1Svg}
        alt=""
        aria-hidden="true"
        class="absolute left-[19.05%] top-[21.43%] h-[30.24%] w-[50.98%]"
      />
      <img
        src={paywallRedeemTreeDots2Svg}
        alt=""
        aria-hidden="true"
        class="absolute left-[14.29%] top-[13.10%] h-[42.86%] w-[64.29%]"
      />
      <img
        src={paywallRedeemTreeTagSvg}
        alt=""
        aria-hidden="true"
        class="absolute left-[53.57%] top-[3.10%] h-[50%] w-[46.36%]"
      />
    </div>
  )
}

function TreeIconBase(props: {
  class?: string
  gradId: string
  children: any
}) {
  const outlineId = `${props.gradId}-outline`
  const fillId = `${props.gradId}-fill`
  return (
    <svg
      class={props.class}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M15.0796 7.34145C17.1197 4.42762 21.5081 4.42808 23.5479 7.34145L27.3156 12.7145L27.3164 12.7153C28.2132 13.9952 28.3977 15.4112 28.0955 16.6808L30.5381 20.0259C31.5595 21.4236 31.7161 22.9894 31.3008 24.3583L33.2133 26.9093C35.8972 30.4898 32.9811 34.9614 29.0757 34.9614H24.2831V35.7704C24.2818 38.5416 21.8345 39.9279 19.9766 39.9284H18.6571C16.8015 39.9284 14.3504 38.5442 14.3491 35.7704V34.9614H9.56044C5.68973 34.9612 2.69941 30.5065 5.4323 26.8967L7.33614 24.3591C6.92026 22.9904 7.07601 21.4245 8.098 20.0259L10.5375 16.6848C10.2316 15.4196 10.4081 14.0041 11.3111 12.7153L11.3119 12.7145L15.0796 7.34145ZM20.8367 9.24294C20.1151 8.20954 18.5123 8.2095 17.7908 9.24294L14.0232 14.616C13.4531 15.4295 13.7292 16.4295 14.4418 16.9549L10.7716 21.98C10.1213 22.8699 10.4961 24.0141 11.3779 24.4887L8.07287 28.8956C7.20018 30.0481 8.07307 31.65 9.56044 31.6501H17.7437C17.697 31.6521 17.6604 31.6844 17.6604 31.7247V35.7688C17.6607 36.2346 18.1102 36.6171 18.6571 36.6171H19.9759C20.5227 36.6169 20.9715 36.2346 20.9718 35.7688V31.7247C20.9718 31.6844 20.9353 31.652 20.8885 31.6501H29.0757C30.5632 31.6501 31.4273 30.0482 30.5633 28.8956L27.259 24.4887C28.1408 24.0141 28.5148 22.8698 27.8646 21.98L24.1951 16.9549C24.9076 16.4295 25.1743 15.4295 24.6043 14.616L20.8367 9.24294Z"
        fill={`url(#${outlineId})`}
      />
      <path
        d="M17.7908 9.24294C18.5123 8.2095 20.1151 8.20954 20.8367 9.24294L24.6043 14.616C25.1743 15.4295 24.9076 16.4295 24.1951 16.9549L27.8646 21.98C28.5148 22.8698 28.1408 24.0141 27.259 24.4887L30.5633 28.8956C31.4273 30.0482 30.5632 31.6501 29.0757 31.6501H20.8885C20.9353 31.652 20.9718 31.6844 20.9718 31.7247V35.7688C20.9715 36.2346 20.5227 36.6169 19.9759 36.6171H18.6571C18.1102 36.6171 17.6607 36.2346 17.6604 35.7688V31.7247C17.6604 31.6844 17.697 31.6521 17.7437 31.6501H9.56044C8.07307 31.65 7.20018 30.0481 8.07287 28.8956L11.3779 24.4887C10.4961 24.0141 10.1213 22.8699 10.7716 21.98L14.4418 16.9549C13.7292 16.4295 13.4531 15.4295 14.0232 14.616L17.7908 9.24294Z"
        fill={`url(#${fillId})`}
      />
      {props.children}
      <defs>
        <linearGradient
          id={outlineId}
          x1="19.3141"
          y1="36.8331"
          x2="19.3141"
          y2="6.48157"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#63FF6B" />
          <stop offset="0.07" stop-color="#64FE77" />
          <stop offset="0.39" stop-color="#6AFAB1" />
          <stop offset="0.66" stop-color="#6FF8DB" />
          <stop offset="0.87" stop-color="#71F6F5" />
          <stop offset="1" stop-color="#73F6FF" />
        </linearGradient>
        <linearGradient
          id={fillId}
          x1="27.1251"
          y1="38.9377"
          x2="6.28275"
          y2="10.6349"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#41C8F8" />
          <stop offset="0.48" stop-color="#22D87A" />
          <stop offset="1" stop-color="#41C8F8" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function PlusIconExclusive(props: IconProps) {
  return (
    <TreeIconBase class={props.class} gradId="plus-icon-exclusive">
      <path
        d="M30.7184 14.3156C30.5066 13.8951 29.8687 13.8951 29.6569 14.3156L27.6547 18.2412C27.4823 18.6301 26.9381 18.73 26.6253 18.4252L24.5 16.373C24.1651 16.0472 23.5765 16.3047 23.6282 16.7566L24.3719 23.4702C24.4384 24.0535 24.9581 24.5002 25.5861 24.5002H34.7892C35.4148 24.5002 35.9418 24.0535 36.0033 23.4702L36.7471 16.7566C36.7963 16.3047 36.2102 16.0472 35.8753 16.373L33.75 18.4252C33.4372 18.73 32.8954 18.6301 32.7205 18.2412L30.7184 14.3156Z"
        fill="url(#plus-icon-exclusive-medal-fill)"
      />
      <path
        d="M27.3184 13.1243C28.503 10.7927 31.8707 10.793 33.0557 13.1243L33.0566 13.1233L33.8496 14.679L34.0518 14.4846C35.0889 13.4815 36.4931 13.4225 37.5117 13.8704C38.5427 14.3238 39.5273 15.4737 39.3564 17.0413V17.0461L38.6133 23.7444L38.6143 23.7454C38.3974 25.7998 36.617 27.1252 34.7891 27.1252H25.5859C23.7333 27.1252 21.9936 25.7835 21.7637 23.7678L21.0195 17.0461L21.0205 17.0452C20.8451 15.4716 21.8358 14.3209 22.8643 13.8694C23.8803 13.4235 25.284 13.481 26.3223 14.4846L26.5244 14.679L27.3184 13.1243ZM30.7184 14.3156C30.5066 13.8951 29.8687 13.8951 29.6569 14.3156L29.2832 15.0461L27.6547 18.2412L27.6182 18.3108C27.4152 18.641 26.9185 18.7109 26.6253 18.4252L24.5 16.373C24.1651 16.0472 23.5765 16.3047 23.6282 16.7566L24.3719 23.4702C24.4384 24.0535 24.9581 24.5002 25.5861 24.5002H34.7892C35.4148 24.5002 35.9418 24.0535 36.0033 23.4702L36.6953 17.2161L36.7471 16.7566C36.7963 16.3047 36.2102 16.0472 35.8753 16.373L35.0039 17.2131L33.75 18.4252L33.6885 18.4778C33.3919 18.7003 32.9489 18.6188 32.7578 18.3108L32.7205 18.2412L30.7184 14.3156Z"
        fill="url(#plus-icon-exclusive-medal-outline)"
      />
      <defs>
        <linearGradient
          id="plus-icon-exclusive-medal-fill"
          x1="30.1875"
          y1="29.5627"
          x2="30.1875"
          y2="14.5297"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stop-color="#008252" />
          <stop offset="0.62" stop-color="#009488" />
          <stop offset="1" stop-color="#00B1DE" />
        </linearGradient>
        <linearGradient
          id="plus-icon-exclusive-medal-outline"
          x1="30.1873"
          y1="23.5656"
          x2="30.1873"
          y2="14.4005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#63FF6B" />
          <stop offset="0.07" stop-color="#64FE77" />
          <stop offset="0.39" stop-color="#6AFAB1" />
          <stop offset="0.66" stop-color="#6FF8DB" />
          <stop offset="0.87" stop-color="#71F6F5" />
          <stop offset="1" stop-color="#73F6FF" />
        </linearGradient>
      </defs>
    </TreeIconBase>
  )
}

export function PlusIconNew(props: IconProps) {
  return (
    <TreeIconBase class={props.class} gradId="plus-icon-new">
      <path
        d="M31.345 12.7515C31.0977 12.0832 30.1523 12.0832 29.905 12.7515L28.4667 16.6384C28.389 16.8486 28.2233 17.0142 28.0132 17.092L24.1263 18.5303C23.4579 18.7776 23.4579 19.7229 24.1263 19.9702L28.0132 21.4085C28.2233 21.4863 28.389 21.6519 28.4667 21.8621L29.905 25.749C30.1523 26.4173 31.0977 26.4173 31.345 25.749L32.7833 21.8621C32.861 21.6519 33.0267 21.4863 33.2368 21.4085L37.1237 19.9702C37.7921 19.7229 37.7921 18.7776 37.1237 18.5303L33.2368 17.092C33.0267 17.0142 32.861 16.8486 32.7833 16.6384L31.345 12.7515Z"
        fill="url(#plus-icon-new-spark-fill)"
      />
      <path
        d="M33.6953 11.5725C32.4956 8.97631 28.7544 8.97631 27.5547 11.5725L27.4434 11.8401L26.3018 14.926L23.2148 16.0686C20.2617 17.1618 20.2617 21.3387 23.2148 22.4319L26.3018 23.5735L27.4434 26.6604C28.5365 29.6135 32.7135 29.6135 33.8066 26.6604L34.9492 23.5735L38.0352 22.4319C40.9883 21.3387 40.9883 17.1618 38.0352 16.0686L34.9492 14.926L33.8066 11.8401L33.6953 11.5725ZM29.905 12.7515C30.1523 12.0832 31.0977 12.0832 31.345 12.7515L32.7833 16.6384L32.8164 16.7151C32.903 16.8885 33.0531 17.0239 33.2368 17.092L37.1237 18.5303C37.7921 18.7776 37.7921 19.7229 37.1237 19.9702L33.2368 21.4085C33.0267 21.4863 32.861 21.6519 32.7833 21.8621L31.345 25.749C31.1129 26.3753 30.2674 26.4147 29.959 25.8665L29.905 25.749L28.4667 21.8621C28.389 21.6519 28.2233 21.4863 28.0132 21.4085L24.7441 20.1975L24.1263 19.9702C23.5 19.7382 23.4605 18.8927 24.0088 18.5842L24.1263 18.5303L28.0132 17.092C28.1969 17.0239 28.347 16.8885 28.4336 16.7151L28.4667 16.6384L29.905 12.7515Z"
        fill="url(#plus-icon-new-spark-outline)"
      />
      <defs>
        <linearGradient
          id="plus-icon-new-spark-fill"
          x1="30.625"
          y1="33.0002"
          x2="30.625"
          y2="12.9562"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stop-color="#008252" />
          <stop offset="0.62" stop-color="#009488" />
          <stop offset="1" stop-color="#00B1DE" />
        </linearGradient>
        <linearGradient
          id="plus-icon-new-spark-outline"
          x1="30.625"
          y1="25.0039"
          x2="30.625"
          y2="12.7837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#63FF6B" />
          <stop offset="0.07" stop-color="#64FE77" />
          <stop offset="0.39" stop-color="#6AFAB1" />
          <stop offset="0.66" stop-color="#6FF8DB" />
          <stop offset="0.87" stop-color="#71F6F5" />
          <stop offset="1" stop-color="#73F6FF" />
        </linearGradient>
      </defs>
    </TreeIconBase>
  )
}

export function PlusIconCrystal(props: IconProps) {
  return (
    <TreeIconBase class={props.class} gradId="plus-icon-crystal">
      <path
        d="M28.1725 6.72084C29.6822 5.81558 31.5678 5.81558 33.0775 6.72084L38.159 9.76745C39.5964 10.6292 40.476 12.1821 40.4759 13.858V20.2675C40.476 21.9434 39.5964 23.4963 38.159 24.358L33.0775 27.4047C31.5678 28.3099 29.6822 28.3099 28.1725 27.4046L23.091 24.358C21.6536 23.4963 20.774 21.9434 20.7741 20.2675V13.858C20.774 12.1821 21.6536 10.6292 23.091 9.76745L28.1725 6.72084Z"
        fill="url(#plus-icon-crystal-body)"
      />
      <path
        d="M34.4771 14.6043C34.5302 14.6368 34.5626 14.6946 34.5626 14.7568V19.3688C34.5626 19.4311 34.5302 19.4889 34.4771 19.5213L30.7183 21.8183C30.6611 21.8533 30.5891 21.8533 30.5319 21.8183L26.7732 19.5213C26.72 19.4889 26.6876 19.4311 26.6876 19.3688V14.7568C26.6876 14.6946 26.72 14.6368 26.7732 14.6043L30.5319 12.3073C30.5891 12.2723 30.6611 12.2723 30.7183 12.3073L34.4771 14.6043Z"
        fill="url(#plus-icon-crystal-center)"
      />
      <path
        d="M22.9953 13.6603C22.8779 13.6135 22.7504 13.7 22.7504 13.8264V20.2935C22.7504 20.4214 22.8807 20.5079 22.9985 20.4583L25.266 19.5035C25.3323 19.4756 25.3754 19.4107 25.3754 19.3388V14.7297C25.3754 14.6565 25.3308 14.5907 25.2628 14.5636L22.9953 13.6603Z"
        fill="url(#plus-icon-crystal-edge-left)"
      />
      <path
        d="M38.2554 13.6603C38.3727 13.6135 38.5003 13.7 38.5003 13.8264V20.2935C38.5003 20.4214 38.37 20.5079 38.2521 20.4583L35.9847 19.5035C35.9184 19.4756 35.8753 19.4107 35.8753 19.3388V14.7297C35.8753 14.6565 35.9199 14.5907 35.9879 14.5636L38.2554 13.6603Z"
        fill="url(#plus-icon-crystal-edge-right)"
      />
      <path
        d="M37.3511 11.9565C37.4672 11.8887 37.4698 11.7219 37.3558 11.6506L32.005 8.30484C31.89 8.23295 31.74 8.31024 31.7318 8.44559L31.5873 10.8298C31.5832 10.8959 31.6162 10.9589 31.6728 10.9933L35.172 13.1204C35.228 13.1545 35.2983 13.1551 35.3549 13.122L37.3511 11.9565Z"
        fill="url(#plus-icon-crystal-tr)"
      />
      <path
        d="M37.3511 22.0171C37.4672 22.0849 37.4698 22.2518 37.3558 22.3231L32.005 25.6688C31.89 25.7407 31.74 25.6634 31.7318 25.5281L31.5873 23.1439C31.5832 23.0777 31.6162 23.0148 31.6728 22.9803L35.172 20.8533C35.228 20.8192 35.2983 20.8186 35.3549 20.8516L37.3511 22.0171Z"
        fill="url(#plus-icon-crystal-br)"
      />
      <path
        d="M24.002 11.9565C23.8859 11.8887 23.8834 11.7219 23.9973 11.6506L29.3481 8.30484C29.4631 8.23295 29.6131 8.31024 29.6213 8.44559L29.7659 10.8298C29.7699 10.8959 29.7369 10.9589 29.6803 10.9933L26.1812 13.1204C26.1251 13.1545 26.0548 13.1551 25.9982 13.122L24.002 11.9565Z"
        fill="url(#plus-icon-crystal-tl)"
      />
      <path
        d="M24.002 22.0171C23.8859 22.0849 23.8834 22.2518 23.9973 22.3231L29.3481 25.6688C29.4631 25.7407 29.6131 25.6634 29.6213 25.5281L29.7659 23.1439C29.7699 23.0777 29.7369 23.0148 29.6803 22.9803L26.1812 20.8533C26.1251 20.8192 26.0548 20.8186 25.9982 20.8516L24.002 22.0171Z"
        fill="url(#plus-icon-crystal-bl)"
      />
      <defs>
        <linearGradient
          id="plus-icon-crystal-body"
          x1="30.6248"
          y1="26.7723"
          x2="30.6248"
          y2="6.1508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#63FF6B" />
          <stop offset="0.07" stop-color="#64FE77" />
          <stop offset="0.39" stop-color="#6AFAB1" />
          <stop offset="0.66" stop-color="#6FF8DB" />
          <stop offset="0.87" stop-color="#71F6F5" />
          <stop offset="1" stop-color="#73F6FF" />
        </linearGradient>
        <linearGradient
          id="plus-icon-crystal-center"
          x1="24.0625"
          y1="24.0627"
          x2="30.625"
          y2="12.7356"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stop-color="#008252" />
          <stop offset="0.62" stop-color="#009488" />
          <stop offset="1" stop-color="#00B1DE" />
        </linearGradient>
        <linearGradient
          id="plus-icon-crystal-edge-left"
          x1="27.1255"
          y1="18.8128"
          x2="17.9381"
          y2="18.7763"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00B1DE" />
          <stop offset="0.38" stop-color="#009488" />
          <stop offset="0.65" stop-color="#008252" />
        </linearGradient>
        <linearGradient
          id="plus-icon-crystal-edge-right"
          x1="31.5005"
          y1="18.3753"
          x2="39.3702"
          y2="17.0315"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stop-color="#008252" />
          <stop offset="0.62" stop-color="#009488" />
          <stop offset="1" stop-color="#00B1DE" />
        </linearGradient>
        <linearGradient
          id="plus-icon-crystal-tr"
          x1="27.562"
          y1="20.1252"
          x2="34.6733"
          y2="9.98462"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stop-color="#008252" />
          <stop offset="0.62" stop-color="#009488" />
          <stop offset="1" stop-color="#00B1DE" />
        </linearGradient>
        <linearGradient
          id="plus-icon-crystal-br"
          x1="36.8952"
          y1="19.6623"
          x2="34.6733"
          y2="23.989"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stop-color="#008252" />
          <stop offset="0.62" stop-color="#009488" />
          <stop offset="1" stop-color="#00B1DE" />
        </linearGradient>
        <linearGradient
          id="plus-icon-crystal-tl"
          x1="22.3127"
          y1="14.0002"
          x2="28.8752"
          y2="9.62523"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stop-color="#008252" />
          <stop offset="0.62" stop-color="#009488" />
          <stop offset="1" stop-color="#00B1DE" />
        </linearGradient>
        <linearGradient
          id="plus-icon-crystal-bl"
          x1="28.4377"
          y1="21.4377"
          x2="22.7502"
          y2="30.1877"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00B1DE" />
          <stop offset="0.38" stop-color="#009488" />
          <stop offset="0.65" stop-color="#008252" />
        </linearGradient>
      </defs>
    </TreeIconBase>
  )
}

export function PlusIcon3x(props: IconProps) {
  return (
    <svg
      class={props.class}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M21.0001 38.0282C11.6049 38.0282 3.97186 30.386 3.97186 20.9999C3.97186 11.6139 11.6049 3.97168 21.0001 3.97168C30.3953 3.97168 38.0284 11.6139 38.0284 20.9999C38.0284 30.386 30.3862 38.0282 21.0001 38.0282Z"
        fill="url(#plus-icon-3x-outline)"
      />
      <path
        d="M34.3576 22.9081H34.3484C34.3576 22.9721 34.3576 23.036 34.3576 23.0999C34.3576 29.3177 28.3771 34.3577 20.9997 34.3577C13.6224 34.3577 7.65105 29.3177 7.65105 23.0999C7.65105 23.036 7.65105 22.9721 7.66018 22.9081H7.65105V18.7538H34.3576V22.9081Z"
        fill="url(#plus-icon-3x-band)"
      />
      <path
        d="M20.9999 30.1577C28.3773 30.1577 34.3486 25.1177 34.3486 18.8999C34.3486 12.6821 28.3682 7.64207 20.9999 7.64207C13.6317 7.64207 7.65122 12.6821 7.65122 18.8999C7.65122 25.1177 13.6317 30.1577 20.9999 30.1577Z"
        fill="url(#plus-icon-3x-face)"
      />
      <path
        d="M20.9997 27.2449C26.4597 27.2449 30.897 23.5106 30.897 18.8997C30.897 14.2889 26.4688 10.5545 20.9997 10.5545C15.5305 10.5545 11.1023 14.2889 11.1023 18.8997C11.1023 23.5106 15.5305 27.2449 20.9997 27.2449Z"
        fill="url(#plus-icon-3x-center)"
      />
      <path
        d="M17.0557 23.1911C15.9692 23.1911 15.047 22.9263 14.3896 22.4332C13.851 22.0224 13.577 21.5111 13.577 20.9176C13.577 20.0137 14.2436 19.3197 15.1475 19.2741C14.9101 19.0002 14.764 18.635 14.764 18.2424C14.764 17.8497 14.901 17.5028 15.1292 17.2289C14.4079 17.0645 13.8875 16.4163 13.8875 15.6128C13.8875 15.1106 14.134 14.6358 14.5723 14.2797C15.1749 13.7776 16.1518 13.4671 17.1105 13.4671C19.1101 13.4671 20.507 14.6724 20.507 16.398C20.507 17.0097 20.3336 17.5667 20.014 18.0324C20.4979 18.5437 20.7627 19.2102 20.7627 19.968C20.7627 21.8306 19.2014 23.1819 17.0466 23.1819L17.0557 23.1911Z"
        fill="url(#plus-icon-3x-three-glow)"
      />
      <path
        d="M18.6535 18.1327C19.4113 18.4614 19.9044 19.0914 19.9044 19.977C19.9044 21.3557 18.7448 22.3144 17.0648 22.3144C16.1061 22.3144 15.3939 22.0862 14.9283 21.7392C14.6361 21.511 14.4626 21.2644 14.4626 20.9175C14.4626 20.461 14.7822 20.1414 15.257 20.1414C15.4944 20.1414 15.7318 20.2418 15.96 20.4153C16.2522 20.6162 16.6083 20.7349 17.0739 20.7349C17.6765 20.7349 18.1239 20.3514 18.1239 19.8492C18.1239 19.347 17.7496 18.9727 16.9279 18.9727H16.4348C16.0057 18.9727 15.6496 18.6805 15.6496 18.2423C15.6496 17.804 16.0057 17.5118 16.4348 17.5118H16.9005C17.5031 17.5118 17.9231 17.1923 17.9231 16.7266C17.9231 16.261 17.5122 15.9231 16.9644 15.9231C16.59 15.9231 16.307 16.0692 16.0422 16.2336C15.8596 16.3431 15.7044 16.407 15.5126 16.407C15.0926 16.407 14.7731 16.0783 14.7731 15.6218C14.7731 15.3936 14.8826 15.1653 15.1383 14.9644C15.54 14.6357 16.2979 14.3527 17.1287 14.3527C18.5531 14.3527 19.6487 15.0923 19.6487 16.407C19.6487 17.0736 19.3383 17.7583 18.6444 18.1327H18.6535Z"
        fill="white"
      />
      <path
        d="M26.6333 23.1911C26.1312 23.1911 25.6472 22.9628 25.3003 22.5611L24.8346 22.0132L24.3781 22.5611C24.0494 22.9628 23.5838 23.1819 23.0542 23.1819C22.1138 23.1819 21.3194 22.3876 21.3194 21.4471C21.3194 21.018 21.4838 20.6071 21.8125 20.2328L22.5155 19.4567L21.8672 18.7354C21.5568 18.4067 21.3742 17.9685 21.3742 17.5119C21.3742 16.5441 22.1594 15.7589 23.1181 15.7589C23.6568 15.7589 24.1316 15.978 24.4603 16.3706L24.8986 16.9093L25.3551 16.3706C25.6746 15.978 26.1494 15.7589 26.6699 15.7589C27.6103 15.7589 28.4046 16.5532 28.4046 17.4937C28.4046 17.9228 28.2403 18.3337 27.9025 18.708L27.1994 19.475L27.8568 20.1598C28.1946 20.5158 28.3772 20.9632 28.3772 21.4106C28.3772 22.3693 27.5738 23.1819 26.6242 23.1819L26.6333 23.1911Z"
        fill="url(#plus-icon-3x-x-glow)"
      />
      <path
        d="M25.9942 21.9493L24.8255 20.5706L23.666 21.9675C23.5107 22.1593 23.3007 22.2597 23.0542 22.2597C22.6251 22.2597 22.2507 21.8853 22.2507 21.4471C22.2507 21.2462 22.3329 21.0453 22.5155 20.8445L23.7664 19.4567L22.5612 18.1145C22.3786 17.9227 22.3055 17.7036 22.3055 17.5119C22.3055 17.0553 22.6799 16.681 23.1273 16.681C23.3555 16.681 23.5838 16.754 23.7573 16.9549L24.8986 18.3427L26.0673 16.964C26.2225 16.7723 26.4325 16.6719 26.679 16.6719C27.1173 16.6719 27.4916 17.0462 27.4916 17.4753C27.4916 17.6762 27.4094 17.8771 27.2268 18.078L25.9486 19.4658L27.1994 20.7806C27.382 20.9723 27.4642 21.1914 27.4642 21.3923C27.4642 21.8397 27.0899 22.2323 26.6333 22.2323C26.396 22.2323 26.1586 22.1136 25.9942 21.9219V21.9493Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="plus-icon-3x-outline"
          x1="21.0001"
          y1="34.9966"
          x2="21.0001"
          y2="5.26972"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#63FF6B" />
          <stop offset="0.07" stop-color="#64FE77" />
          <stop offset="0.39" stop-color="#6AFAB1" />
          <stop offset="0.66" stop-color="#6FF8DB" />
          <stop offset="0.87" stop-color="#71F6F5" />
          <stop offset="1" stop-color="#73F6FF" />
        </linearGradient>
        <linearGradient
          id="plus-icon-3x-band"
          x1="36.2921"
          y1="35.4959"
          x2="23.8849"
          y2="14.2491"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0D9E48" />
          <stop offset="0.48" stop-color="#06957E" />
          <stop offset="1" stop-color="#008BBD" />
        </linearGradient>
        <linearGradient
          id="plus-icon-3x-face"
          x1="36.2828"
          y1="31.8"
          x2="16.0231"
          y2="7.7643"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#77F2A9" />
          <stop offset="0.48" stop-color="#4AF29B" />
          <stop offset="1" stop-color="#41C8F8" />
        </linearGradient>
        <linearGradient
          id="plus-icon-3x-center"
          x1="16.1875"
          y1="6.99976"
          x2="30.0564"
          y2="37.8801"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00CD2C" />
          <stop offset="0.06" stop-color="#00CA3F" />
          <stop offset="0.23" stop-color="#03C471" />
          <stop offset="0.4" stop-color="#05BF9B" />
          <stop offset="0.57" stop-color="#06BBBB" />
          <stop offset="0.72" stop-color="#08B8D3" />
          <stop offset="0.87" stop-color="#08B6E1" />
          <stop offset="1" stop-color="#09B6E6" />
        </linearGradient>
        <radialGradient
          id="plus-icon-3x-three-glow"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.8621 19.4796) scale(3.32254 3.48525)"
        >
          <stop stop-color="#E0FDFF" stop-opacity="0.8" />
          <stop offset="0.12" stop-color="#D9FCFF" stop-opacity="0.76" />
          <stop offset="0.33" stop-color="#C6FBFF" stop-opacity="0.66" />
          <stop offset="0.6" stop-color="#A7F9FF" stop-opacity="0.49" />
          <stop offset="0.92" stop-color="#7DF6FF" stop-opacity="0.26" />
          <stop offset="1" stop-color="#73F6FF" stop-opacity="0.2" />
        </radialGradient>
        <radialGradient
          id="plus-icon-3x-x-glow"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.8621 19.4796) scale(3.32254 3.48525)"
        >
          <stop stop-color="#E0FDFF" stop-opacity="0.8" />
          <stop offset="0.12" stop-color="#D9FCFF" stop-opacity="0.76" />
          <stop offset="0.33" stop-color="#C6FBFF" stop-opacity="0.66" />
          <stop offset="0.6" stop-color="#A7F9FF" stop-opacity="0.49" />
          <stop offset="0.92" stop-color="#7DF6FF" stop-opacity="0.26" />
          <stop offset="1" stop-color="#73F6FF" stop-opacity="0.2" />
        </radialGradient>
      </defs>
    </svg>
  )
}
